import { css } from 'goober';

export const GlobalStyle = css`
  font-family: apple-system, BlinkMacSystemFont, Roboto, sans-serif;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  a{
    text-decoration: none;
  }
`;
